import { createObjectPagePathname, getAsServerMediaUrl, getMediaUrl } from "@/services/pathname"
import Link from "next/link"
import { formatPrice } from "@/services/number"
import { getName } from "@/services/aroeven"
import Image from "next/image"

type CardProps = {
    aroeven: Aroeven,
    publication: Publication
}
export default function Card({
    aroeven,
    publication
}: CardProps) {

    return (
        <Link href={(aroeven.federation === false && publication.publishedBy.slug !== aroeven.slug ? publication.publishedBy.url : '') + createObjectPagePathname('Publication', publication)} {...aroeven.federation === false && publication.publishedBy.slug !== aroeven.slug && { target: "_blank" }} className="vignette -type-1 h-100">
            {publication.mainImage &&
                <div className="vignette__image">
                    <div className="cardImage ratio ratio-1:1">
                        <div className="cardImage__content">
                            <Image
                                src={getAsServerMediaUrl(publication.mainImage?.url ?? '#')}
                                width={publication.mainImage.metadata.width}
                                height={publication.mainImage.metadata.height}
                                className="col-12"
                                alt="image"
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                quality={50}
                            />
                            {/*<img className="col-12" src={getMediaUrl(publication.mainImage?.url ?? '#')} alt="image" />*/}
                        </div>
                        <div className="cardImage__leftBadge">
                            <div className="tag">
                                <h3 className="tag-title"><i className="fi fi-rr-books me-1 text-primary-4" /> {publication.collection.name}</h3>
                                <div className="tag-tail" />
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div className="vignette__content mt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <h4 className="vignette__title lh-16">
                            {publication.title}
                        </h4>
                        <p>{publication.short}</p>
                        <div className="tarif d-flex justify-content-end">{formatPrice(publication.price)} €</div>
                    </div>
                    <div className="d-flex flex-column justify-content-end">
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>Publié par {getName(publication.publishedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>

    )
}